export const VIEW_FOLDER = "app/FOLDER_CONTENT/VIEW_FOLDER";
export const VIEW_FOLDER_SUCCESS = "app/FOLDER_CONTENT/VIEW_FOLDER_SUCCESS";
export const VIEW_FOLDER_FAILURE = "app/FOLDER_CONTENT/VIEW_FOLDER_FAILURE";

export const UPDATE_VIEW_FOLDERS = "app/FOLDER_CONTENT/UPDATE_VIEW_FOLDERS";
export const UPDATE_VIEW_FILES = "app/FOLDER_CONTENT/UPDATE_VIEW_FILES";

export const VIEW_VERSION = "app/FOLDER_CONTENT/VIEW_VERSION";
export const VIEW_VERSION_SUCCESS = "app/FOLDER_CONTENT/VIEW_VERSION_SUCCESS";
export const VIEW_VERSION_FAILURE = "app/FOLDER_CONTENT/VIEW_VERSION_FAILURE";

export const COPY_LINK = "app/FOLDER_CONTENT/COPY_LINK";
export const COPY_LINK_SUCCESS = "app/FOLDER_CONTENT/COPY_LINK_SUCCESS";
export const COPY_LINK_FAILURE = "app/FOLDER_CONTENT/COPY_LINK_FAILURE";

export const DOWNLOAD_FILE = "app/FOLDER_CONTENT/DOWNLOAD_FILE";
export const DOWNLOAD_FILE_SUCCESS = "app/FOLDER_CONTENT/DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAILURE = "app/FOLDER_CONTENT/DOWNLOAD_FILE_FAILURE";

export const ACKNOWLEDGE_POLICY = "app/FOLDER_CONTENT/ACKNOWLEDGE_POLICY";
export const ACKNOWLEDGE_POLICY_SUCCESS =
  "app/FOLDER_CONTENT/ACKNOWLEDGE_POLICY_SUCCESS";
export const ACKNOWLEDGE_POLICY_FAILURE =
  "app/FOLDER_CONTENT/ACKNOWLEDGE_POLICY_FAILURE";

export const FETCH_POLICY_ACKNOWLEDGEMENT_REPORT =
  "app/FOLDER_CONTENT/FETCH_POLICY_ACKNOWLEDGEMENT_REPORT";
export const FETCH_POLICY_ACKNOWLEDGEMENT_REPORT_SUCCESS =
  "app/FOLDER_CONTENT/FETCH_POLICY_ACKNOWLEDGEMENT_REPORT_SUCCESS";
export const FETCH_POLICY_ACKNOWLEDGEMENT_REPORT_FAILURE =
  "app/FOLDER_CONTENT/FETCH_POLICY_ACKNOWLEDGEMENT_REPORT_FAILURE";
